// removed by extract-text-webpack-plugin
module.exports = {"Form_wrap":"UpdateVaccintion__Form_wrap__105Ja","Form_group":"UpdateVaccintion__Form_group__3ROxy","ContainerBtn":"UpdateVaccintion__ContainerBtn__1Qpa0","Btn":"UpdateVaccintion__Btn__36sRn","RedBtn":"UpdateVaccintion__RedBtn__fSitS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VaccinationController/UpdateVaccintion/UpdateVaccintion.css
// module id = 129
// module chunks = 0